import { render, staticRenderFns } from "./OnboardingVerification.vue?vue&type=template&id=2b83052e&"
import script from "./OnboardingVerification.vue?vue&type=script&lang=js&"
export * from "./OnboardingVerification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports